<template>
  <FiringsComponent/>
</template>

<script>
  import FiringsComponent from '../components/FiringsComponent'

  export default {
    components: {
      FiringsComponent
    }
  }
</script>